<app-conversations [getConversationByLeadIds]="true" [leadIds]="leadIds"></app-conversations>
